<ng-template #templateModalForm role="document" let-modal>

  <app-page-comp-header [title]="formTitle" [showBottomBorder]="false">
  </app-page-comp-header>

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form [formGroup]="templateForm" class="tablelist-form" autocomplete="off">
      <div class="modal-body">

        @if(!this.hideMessageType) {
        <div class="mb-3 d-flex align-items-center gap-2">
          <label class="form-label fw-semibold mb-0 required">Message Type</label>
          <span class="text-muted font-normal">{{ messageType }}</span>
        </div>
        }

        <!-- Template Name -->
        <div class="mb-3">
          <label class="form-label fw-semibold required">Template Name</label>
          <input autocomplete="no-fill" type="text" id="templateName-field" class="form-control" placeholder="" formControlName="templateName" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['templateName'].errors }" />
        </div>

        <!-- Subject -->
        <div class="mb-3" (click)="handleMouseClick($event)" (keyup)="handleKeyUp($event)">
          <label class="form-label fw-semibold required">Subject</label>
          <input autocomplete="no-fill" type="text" id="subject-field" class="form-control" placeholder="" formControlName="subject" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['subject'].errors }" />
        </div>

        <!-- Notification -->
        <div class="mb-3" (click)="handleMouseClick($event)" (keyup)="handleKeyUp($event)">
          <label for="desc-field" class="form-label fw-semibold required">
            Notification
            <i
              title="To insert a system value, type @@ or hold the Ctrl key down and click where you want to place it."
              class="bi bi-info-circle text-secondary ms-1"
              style="cursor: pointer;">
            </i>
          </label>
          <textarea
            id="desc-field"
            class="form-control resize-none"
            placeholder=""
            formControlName="notification"
            data-lpignore="true"
            [ngClass]="{ 'is-invalid': this.getDodgySystemPlaceHolders(formData['notification'].value) != '' }"
            rows="6">
          </textarea>
          <div class="invalid-feedback">Unknown system value(s) found - {{this.getDodgySystemPlaceHolders(formData['notification'].value)}}</div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between align-items-center pt-3 border-top">
          <div>
            <button *ngIf="template.id > 0" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="saveAsNew()">Save As Copy</button>
          </div>
          <div class="hstack gap-2">
            @if(!embeddedFormMode) {
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm(templateModalAction);modal.close('Close click')">Cancel</button>
            }
            <button *ngIf="canEditTemplate" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="save()">Save</button>
            @if(!this.hideSaveAndEnable) {
              <button *ngIf="canEditTemplate && !alreadyEnabled" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="saveAndEnable()">Save & Enable</button>
            }
          </div>
        </div>

      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-input-modal-form #inputModalForm
  fieldCaption="System Value"
  formTitle="Insert System Value"
  [input0EnforceEmailValidation]="false"
  [input0EnforceMaxLengthValidation]="false"
  [input0EnforceRequiredValidation]="false"
  [input0Values]="this.templateReplacementsValues"
  (thisFormSaved)="inputModalFormSubmitted($event)"
></app-input-modal-form>
